import http from '@/utils/api';

export const prepareExport = async (objectId, type) => {
  try {
    await http.post(`export-service/prepare/${objectId}`, { type });
  } catch (e) {
    console.error(e);
  }
};

export default { prepareExport };
